import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Loader2, MailCheck } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function ForgotUsername() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-username", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-cream">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} className="w-full max-w-md">
        <div className="font-sans text-xl tracking-[0.25em] mb-10">OMNIA</div>
        {sent ? (
          <div data-testid="forgot-username-sent" className="space-y-4">
            <MailCheck className="w-8 h-8 text-violet" />
            <h2 className="text-2xl font-medium tracking-tight">Revisa tu correo</h2>
            <p className="text-navy/60">Si tu correo está registrado en OMNIA, te enviamos tu nombre de usuario a tu correo personal. Revisa también la bandeja de spam.</p>
            <Link to="/login" className="text-violet hover:underline inline-block">Volver a iniciar sesión</Link>
          </div>
        ) : (
          <>
            <div className="overline text-navy/40 mb-3">Recuperar acceso</div>
            <h2 className="text-3xl font-medium tracking-tight mb-2">¿Olvidaste tu usuario?</h2>
            <p className="text-navy/60 mb-8">Escribe tu correo personal (el que registraste en OMNIA) y te enviaremos tu nombre de usuario.</p>
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-username-form">
              <input data-testid="forgot-username-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                autoCapitalize="none" placeholder="tu-correo@ejemplo.com"
                className="w-full bg-white border border-navy/10 rounded-lg px-4 py-3 outline-none focus:border-violet transition-colors" />
              {error && <p data-testid="forgot-username-error" className="text-sm text-destructive">{error}</p>}
              <button data-testid="forgot-username-submit" type="submit" disabled={loading}
                className="group w-full inline-flex items-center justify-center gap-2 rounded-full bg-navy text-white py-3.5 hover:bg-navy-soft transition-colors disabled:opacity-60">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar mi usuario"}
                {!loading && <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />}
              </button>
            </form>
            <Link to="/login" className="mt-6 inline-block text-sm text-navy/50 hover:text-navy">Volver a iniciar sesión</Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
